<template>
  <DeleteModal
    ref="deleteModal"
    :currently-selected-entry="selectedVenue ? selectedVenue.name : ''"
    @close="selectedVenue = null"
    @delete="handleDelete"
  />
  <VenueModal
    ref="venueModal"
    :title="selectedVenue ? 'Edit Venue' : 'Create Venue'"
    :currently-selected-venue="selectedVenue"
    @close="selectedVenue = null"
    @saved="fetch"
  />
  <div class="card d-flex flex-column w-100 p-8">
    <div class="d-flex align-items-center justify-content-between w-100">
      <div class="d-flex  flex-column">
        <h3 class="card-label fw-bolder fs-3 ">Venues</h3>
        <span class="text-muted  fw-bold fs-7">List of venues</span>
      </div>
      <button
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        data-bs-trigger="hover"
        title="Click to add a new venue"
        class="btn d-flex align-items-center justify-content-center btn-success h-35px"
        @click="handleOpenModal(null, 'create')"
      >
        <span class="svg-icon svg-icon-3"><plus-sign-svg /></span>
        Add new Venue
      </button>
    </div>
    <div class="gap-5 mt-5 d-flex justify-content-start w-100">
      <CountriesDropdown
        class="mw-350px"
        @change="handleSelectCountry"
        :placeholder="'Select venue country'"
      />
      <SearchField
        @changeSearch="handleSearch"
        class="mh-40px"
        :placeholder="'Search venues'"
      />
    </div>
    <div class="w-100 my-5">
      <el-menu
        @select="handleSelectMenu"
        :default-active="1"
        class="el-menu-demo"
        mode="horizontal"
      >
        <el-menu-item :index="1">My Venues</el-menu-item>
        <el-menu-item :index="2" v-if="$can('can_view_all_venues', 'all')"
          >All Venues</el-menu-item
        >
      </el-menu>
    </div>
    <div class="w-100" v-loading="loading">
      <VenuesDataTable
        :table-data="getData"
        @openEditModal="ev => handleOpenModal(ev, 'edit')"
        @openDeleteModal="ev => handleOpenModal(ev, 'delete')"
      />
    </div>
    <div class="d-flex w-100 justify-content-end mt-5">
      <el-pagination
        :current-page="pagination.currentPage"
        :page-count="pagination.totalPages"
        @current-change="handleChangePage"
        layout="prev, pager, next"
        :hide-on-single-page="true"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";
import PlusSignSvg from "@/components/Icons/PlusSign.vue";
import SearchField from "@/components/general/SearchField.vue";
import CountriesDropdown from "@/components/dropdown/CountriesDropdown.vue";
import VenuesDataTable from "@/components/venues/VenuesDataTable.vue";
import DeleteModal from "@/components/general/DeleteModal.vue";
import VenueModal from "@/components/venues/modal/VenueModal.vue";

export default defineComponent({
  name: "VenuesIndex",
  data() {
    return {
      activeIndex: 1,
      pagination: {
        currentPage: 1,
        totalPages: 1
      },
      search: "",
      country: null,
      selectedVenue: null
    };
  },
  components: {
    VenueModal,
    DeleteModal,
    VenuesDataTable,
    CountriesDropdown,
    SearchField,
    PlusSignSvg
  },
  methods: {
    ...mapActions("VenuesModule", ["resetState", "fetchData", "destroyData"]),
    handleSelectMenu(index) {
      this.activeIndex = index;
      this.fetch();
    },
    fetch() {
      this.fetchData({
        page: this.pagination.currentPage,
        search: this.search,
        country: this.country,
        type: this.activeIndex
      }).then(data => {
        this.pagination.currentPage = data.current_page;
        this.pagination.totalPages = data.last_page;
      });
    },
    scrollToTop() {
      if (window) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    handleChangePage(page) {
      this.pagination.currentPage = page;
      this.fetch();
      this.scrollToTop();
    },
    handleSearch(searchString) {
      this.search = searchString;
      this.fetch();
    },
    handleSelectCountry(country) {
      this.country = country;
      this.fetch();
    },
    handleOpenModal(venue, type) {
      this.selectedVenue = venue;
      switch (type) {
        case "create":
          this.$refs.venueModal.toggleModal(true, this.selectedVenue);
          break;
        case "edit":
          this.$refs.venueModal.toggleModal(true, this.selectedVenue);
          break;
        case "delete":
          this.openModal(this.$refs.deleteModal);
          break;
      }
    },
    handleDelete() {
      if (this.selectedVenue) {
        this.destroyData(this.selectedVenue.id).then(() => {
          this.fetch();
        });
      }
    },
    openModal(ref) {
      if (ref) {
        const modal = ref.modal;
        if (modal) {
          modal.show();
        }
      }
    }
  },
  computed: {
    ...mapGetters("VenuesModule", ["getData", "loading"])
  },
  mounted() {
    this.fetch();
  },
  unmounted() {
    this.resetState();
  }
});
</script>
